import { useEffect } from "react";

/**
 * Injects a <meta name="robots" content="noindex, nofollow"> tag while the
 * component is mounted. Removes it on unmount so public pages stay indexable.
 */
const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);
};

export default useNoIndex;
